"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOTIFY = exports.CLEAN = void 0;
// USE THIS FILE TO CREATE AND EXPORT YOUR MODULE VARIABLES
var NOTIFY = exports.NOTIFY = '@Notification/NOTIFY';
var CLEAN = exports.CLEAN = '@Notification/CLEAN';